
import TableList from "@components/templates/tablelist";
import { HttpGetRulesList, HttpActiveRule, HttpDisableRule } from '@/service/rules/rules'
import { mapState, mapGetters } from "vuex";
import mixin from './../mixin'
import mixin1 from './mixin'
import compUpdate from './update'
export default {
    mixins: [TableList, mixin, mixin1],
    components: {
        compUpdate
    },
    data() { 
        return {
            isMixin: true,
            Tools: {show: true},
            formData:{
                search:{
                    'EQ_ruleType': 4,
                }
            },
            Searchs: {
                show: true,
                labelWidth: 100,
            },
            Plugins: {show: true},
            // warehouseList: []
        };
    },
    created () {
        // console.log(this.getNewWarehouseIdList)
        // this.warehouseList = this.getNewWarehouseIdList
        //     .filter((item) => {
        //         // 过滤只展示服务仓和虚拟仓
        //         return (
        //             item.attach.item.warehouseType === 1 ||
        //             item.attach.item.warehouseType === 5
        //         );
        //     })
        //     .map((item) => {
        //         return item;
        //     });
    },
    methods: {
        ajaxRequest: HttpGetRulesList,
        interceptRequest: (params) => {
            let tempSearchData = params.search
            let { IN_channelId, IN_lineId, ...searchData } = { ...tempSearchData }
            return {
                ...params,
                search: {
                    ...searchData,
                    EQ_ruleType: 4
                },
                channelId: IN_channelId,
                productId: IN_lineId
            }
        },
        
        handleOperates (param, type) {
            switch (type) {
                case 'add':
                    {
                        this.$router.push({
                            name: 'orderRulesUpdate',
                            params: { 
                                type: 'add'
                            },
                        })
                    }
                    break;
                case 'query':
                    {
                        this.operate = {
                            show: true,
                            width: 1200,
                            title: this.$t('global.common.operation_see',{defaultValue:'查看'}),
                            id: param,
                            type: type,
                            level: this.type,
                            component: 'compUpdate',
                            showFooter: false
                        }
                    }
                break;
                case 'edit':
                    {
                        const url = this.$router.resolve({
                            name: 'orderRulesUpdate',
                            params: {
                                type: 'edit'
                            },
                            query: { id: param }
                        })
                        window.open(url.href, '_blank');
                    }
                break;
                case 'disable':
                    {
                        this.loading = true;
                        HttpDisableRule({
                            ruleId: param,
                        })
                            .then(
                                (res) => {
                                    this.$VMessage.success(res.message);
                                    this.startUp ++
                                },
                                (err) => {
                                    this.$VMessage.error({
                                        content: err.message,
                                        duration: 30,
                                        closable: true
                                    });
                                }
                            )
                            .finally(() => {
                                this.loading = false;
                            });
                    }
                break;
                case 'active':
                    {
                        this.loading = true;
                        HttpActiveRule({
                            ruleId: param,
                        })
                            .then(
                                (res) => {
                                    this.$VMessage.success(res.message);
                                    this.startUp ++
                                },
                                (err) => {
                                    this.$VMessage.error({
                                        content: err.message,
                                        duration: 30,
                                        closable: true
                                    });
                                }
                            )
                            .finally(() => {
                                this.loading = false;
                            });
                    }
                break;
            }
        },
        getOperateNodeMap(row){
            const { id } = row
            return [
                {
                    label:this.$t('global.common.operation_see',{defaultValue:'查看'}),
                    params:id,
                    operate:'query'
                },{
                    label:this.$t('global.common.operation_edit',{defaultValue:'编辑'}),
                    params:id,
                    operate:'edit'
                }, 
                // {
                //     label: this.$t('fbb.accountmanage.active',{defaultValue:'启用'}),
                //     show: row.ruleStatus == 0 ? true : false,
                //     params: id,
                //     operate: 'active'
                // }, 
                // {
                //     label: this.$t('global.common.failure',{defaultValue:'失效'}),
                //     show: row.ruleStatus == 1 ? true : false,
                //     params:id,
                //     operate:'disable'
                // }
            ]
        },
    },
    computed: {
        ...mapGetters('diction',['getNewProductList', 'getNewAccountIdList', 'getNewWarehouseIdList']),
        // getBind() {
        //     return {
        //         on: {
        //             'on-query': this.queryChange
        //         }
        //     }
        // },
        // TabsData(){
        //     return [
        //         {
        //             name: this.$t('bi.work.task_all',{defaultValue:'全部'}),
        //             key:'EQ_status',
        //             val: null
        //         }, {
        //             name: this.$t('	global.common.effective',{defaultValue:'有效'}),
        //             key:'EQ_status',
        //             val: '1'
        //         }, {
        //             name: this.$t('global.common.failure',{defaultValue:'失效'}),
        //             key:'EQ_status',
        //             val: '0'
        //         }
        //     ]
        // },
        ToolsData(){
            return [
                {
                    name: this.$t('global.common.add',{defaultValue:'添加'}),
                    operate: "add",
                    theme: "primary",
                },
            ]
        },
        SearchsData() {
            let widthStyle = 'width: 250px'
            return  [
                {
                    label: this.$t('erp.b2c.channel_account',{defaultValue:'渠道账号'}),
                    key: "IN_channelId",
                    tag: "Select",
                    show: true,
                    // class:"height30",
                    options: this.getNewAccountIdList,
                    props: {
                        filterable: true,
                        clearable: true,
                    },
                },
                {
                    label: this.$t('global.common.project',{defaultValue:'项目'}),
                    key: "IN_lineId",
                    tag: "Select",
                    show: true,
                    options: this.getNewProductList,
                    props: {
                        filterable: true,
                        clearable: true,
                    },
                },
                // {
                //     label: this.$t('erp.b2c.search_outwarehouse',{defaultValue:'发货仓库'}),
                //     key: "IN_warehouseId",
                //     tag: "Select",
                //     show: true,
                //     options: this.warehouseList,
                //     props: {
                //         filterable: true,
                //         clearable: true,
                //     },
                // },
                {
                    label: "发货方式",
                    key: "IN_warehouseName",
                    tag: "Select",
                    options: this.serviceCodeList,
                    props: {
                        multiple: true,
                        filterable: true,
                        clearable: true,
                    },
                    show: true,
                },
                {
                    label: this.$t('global.common.status',{defaultValue:'状态'}),
                    key: "EQ_ruleStatus",
                    tag: "Select",
                    options: this.statusList,
                    show: true,
                },
                // {
                //     label: this.$t('erp.distribution.issfp',{defaultValue:'是否SFP'}),
                //     key: "EQ_sfpType",
                //     tag: "Select",
                //     options: this.sfpList,
                // },
                {
                    label: this.$t('global.common.updatedAt',{defaultValue:'更新时间'}),
                    key: "BT_updatedAt",
                    tag: "vDatepicker",
                    props: {
                        type: "daterange",
                        format:'yyyy-mm-dd ~ yyyy-mm-dd',
                        confirm:false,
                    },
                    show: true,
                },
            ]
        },
        columns() {
            let that = this;
            return [
                {
                    title: this.$t('global.common.operation',{defaultValue:'操作'}),
                    width: 100,
                    render(h, { row }) {
                        let dropDown = {}
                        // 启用
                        if (row.ruleStatus == 1) {
                            dropDown.label = that.$t('fbb.accountmanage.disable',{defaultValue:'禁用'})
                            dropDown.value = 'disable'
                        }
                        else {
                            dropDown.label = that.$t('fbb.accountmanage.active',{defaultValue:'启用'})
                            dropDown.value = 'active'
                        }

                        return (
                            <div>
                                <vDropdown
                                    trigger="click"
                                >
                                    <vButton size="small" theme="info">
                                        {that.$t('global.common.operation',{defaultValue:'操作'})}
                                        <vIcon type="arrow-dropdown" />
                                    </vButton>
                                    <vDropdownMenu style="font-size: 12px;" slot="list">
                                        <vDropdownItem nativeOnClick={that.handleOperates.bind(this, row.id, 'query')}>{that.$t('global.common.operation_see',{defaultValue:'查看'})}</vDropdownItem>
                                        <vDropdownItem nativeOnClick={that.handleOperates.bind(this, row.id, 'edit', )}>{that.$t('global.common.operation_edit',{defaultValue:'编辑'})}</vDropdownItem>
                                        <vDropdownItem nativeOnClick={that.handleOperates.bind(this, row.id, dropDown.value)}>{dropDown.label}</vDropdownItem>
                                    </vDropdownMenu>
                                </vDropdown>
                            </div>
                        );
                    },
                },
                {
                    title: this.$t('erp.rules.rulename',{defaultValue:'规则名称'}),
                    key: "id",
                    render(h, { row }) {
                        return (
                            <div>
                                <a onClick={that.handleOperates.bind(this, row.id, 'query', 'query')}>{row.ruleName}</a>
                            </div>
                        )
                    }
                },
                {
                    title: "发货方式",
                    key: "warehouseName",
                },
                {
                    title: this.$t('global.common.status',{defaultValue:'状态'}),
                    key: "ruleStatus",
                    render(h, { row }) {
                        let obj = that.statusList.filter((item) => {
                            return item.value === row.ruleStatus;
                        })[0];
                        return <div>{obj.label}</div>;
                    },
                },
                {
                    title: this.$t('global.common.updatedAt',{defaultValue:'更新时间'}),
                    key: "updatedAt",
                },
            ];
        },

    }

};
